<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-md-6 mt-4">
        <form>
          <div class="form-group">
            <label for="email">E-mail</label>

            <input
              v-model="email"
              :class="[{ 'is-invalid': errorFor('email') }]"
              name="email"
              type="email"
              required
              placeholder="Enter your e-mail"
              class="form-control"
            />
            <v-errors :errors="errorFor('email')"></v-errors>
          </div>
          <div class="form-group">
            <label for="email">Password</label>
            <input
              v-model="password"
              :class="[{ 'is-invalid': errorFor('password') }]"
              name="password"
              type="password"
              required
              placeholder="Enter your password"
              class="form-control"
            />
            <v-errors :errors="errorFor('password')"></v-errors>
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-lg btn-block"
            :disabled="loading"
            @click.prevent="login"
          >
            Log-in
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { logIn, isLoggedIn } from "./../js/utils/auth";
import validationErrors from "../js/mixins/validationErrors";
import axios from "axios";

export default {
  mixins: [validationErrors],
  name: "Home",
  data() {
    return {
      email: null,
      password: null, //"password",
      errorMessage: "",
      loading: false,
    };
  },
  mounted() {
    /*axios.get("/api/foods/list").then((response) => {
      this.foods = response.data;
      console.log(response.data);
    });*/
  },

  methods: {
    async login() {
      this.loading = true;
      this.errors = null;

      try {
        await axios.get("/sanctum/csrf-cookie");

        await axios
          .post("/api/login", {
            email: this.email,
            password: this.password,
            device_name: "browser",
          })
          .then((response) => {
            //console.log(response);
            localStorage.setItem("token", response.data);
            localStorage.setItem("user_role", response.data.role);
          });

        logIn();

        this.$store.dispatch("loadUser");
        this.$router.push({ name: "Checkin" });
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
      }
      this.loading = false;
    },
  },
};
</script>
